import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { NonIdealState } from '@/shared/components/NonIdealState';

export const EmptyChatState: FC = () => {
  const { t } = useTranslation(LocalizationNameSpace.CHATS, {
    keyPrefix: 'components.emptyChatState'
  });

  // Todo: maybe use Empty card component
  return <NonIdealState text={`${t('chatIsPrivate')}\n${t('startWriting')}`} />;
};
